import { UserProfile } from '../providers/interfaces/profile-fetcher.interface';

export abstract class BaseProfileFetcher {
  constructor(protected profileEndpoint: string) {}

  /**
   * Fetch user profile information from the OAuth provider
   * @param accessToken The OAuth access token
   * @returns Promise resolving to standardized user profile
   */
  async fetchUserInfo(accessToken: string): Promise<UserProfile> {
    const response = await fetch(this.profileEndpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        ...this.getAdditionalHeaders(),
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch profile from ${this.profileEndpoint}: ${response.statusText}`,
      );
    }

    const rawData = await response.json();
    return this.mapToUserProfile(rawData);
  }

  /**
   * Map the raw API response to our standardized UserProfile structure
   * Override this method to customize mapping for different providers
   */
  protected abstract mapToUserProfile(rawData: any): UserProfile;

  /**
   * Get additional headers if needed for the profile request
   * Override this method to add provider-specific headers
   */
  protected getAdditionalHeaders(): Record<string, string> {
    return {};
  }

  /**
   * Get the profile endpoint URL
   */
  getEndpoint(): string {
    return this.profileEndpoint;
  }
}
